module.exports = __webpack_public_path__ + "img/img-sv388.2a06dd2a.png";